import React, { useEffect } from 'react';
// BottomSheetModal removed - using regular div
import { trackSubscriptionPromptViewed, trackTrialStoryCompleted, trackSubscriptionPromptDismissed } from '../../utils/speakrootsAnalytics.js';

const StorybookUpsellModal = ({ isOpen, onClose, onUpgrade, language = 'Twi' }) => {
  // Track subscription prompt viewed when modal opens
  useEffect(() => {
    if (isOpen) {
      trackSubscriptionPromptViewed('storybook_upsell');
      trackTrialStoryCompleted('unknown', language, 'trial_story');
    }
  }, [isOpen, language]);

  if (!isOpen) return null;

  // Check if device is mobile (consistent with App.js breakpoint)
  const isMobile = window.innerWidth < 1024;

  const storyInfo = language === 'Twi' 
    ? { 
        title: 'Ananse Story', 
        character: '🕷️',
        description: 'the wise spider'
      }
    : { 
        title: 'Ijapa Story', 
        character: '🐢',
        description: 'the clever tortoise'
      };

  const content = (
    <div className="text-center">
      <span className="text-6xl mb-4 block">{storyInfo.character}</span>
      <h2 className="text-2xl font-extrabold mb-2">Enjoyed the story?</h2>
      <p className="text-gray-600 mb-6">
        You just experienced {storyInfo.description} in our {storyInfo.title}! Subscribe now to unlock our full library of interactive stories, with new chapters and songs added in the future!
      </p>
      
      <div className="space-y-3 mb-6">
        <div className="flex items-center text-left">
          <span className="text-green-500 mr-3">✅</span>
          <span className="text-sm">Full library of interactive stories</span>
        </div>
        <div className="flex items-center text-left">
          <span className="text-green-500 mr-3">✅</span>
          <span className="text-sm">New chapters and songs added regularly</span>
        </div>
        <div className="flex items-center text-left">
          <span className="text-green-500 mr-3">✅</span>
          <span className="text-sm">Access all 12 Units and 100+ lessons</span>
        </div>
        <div className="flex items-center text-left">
          <span className="text-green-500 mr-3">✅</span>
          <span className="text-sm">Unlimited Game Zone plays</span>
        </div>
      </div>

      <div className="space-y-3 mb-6">
        <div className="bg-blue-50 border-4 border-blue-500 rounded-xl p-4 relative">
          <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-yellow-400 text-yellow-900 text-xs font-bold px-2 py-0.5 rounded-full">
            BEST VALUE
          </div>
          <div className="text-2xl font-bold text-gray-900">$90/year</div>
        </div>
        <div className="bg-white border-4 border-gray-200 rounded-xl p-4">
          <div className="text-xl font-bold text-gray-900">$10/month</div>
          <div className="text-sm text-gray-600">Monthly billing</div>
        </div>
      </div>

      <div className="space-y-3">
        <button 
          onClick={onUpgrade} 
          className="w-full bg-green-500 text-white font-bold py-4 rounded-xl transition active:scale-95 min-h-[48px]"
        >
          Unlock Everything
        </button>
        <button 
          onClick={() => {
            trackSubscriptionPromptDismissed('storybook_upsell');
            onClose();
          }} 
          className="w-full text-gray-600 font-bold py-3 min-h-[44px]"
        >
          Maybe Later
        </button>
      </div>
    </div>
  );

  // Use bottom sheet on mobile, center modal on desktop
  if (isMobile) {
    return (
      <div className={`fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4 overflow-y-auto ${isOpen ? 'block' : 'hidden'}`}>
        <div className="bg-white rounded-2xl p-6 text-center w-full max-w-md mx-auto my-auto max-h-[90vh] overflow-y-auto">
          <h2 className="text-2xl font-bold mb-4">Story Complete!</h2>
          {content}
        </div>
      </div>
    );
  }

  // Desktop version (center modal)
  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4 overflow-y-auto">
      <div className="bg-white rounded-2xl p-6 text-center w-full max-w-md mx-auto my-auto max-h-[90vh] overflow-y-auto">
        {content}
      </div>
    </div>
  );
};

export default StorybookUpsellModal;